import { useEffect, useState } from "react";
import { State } from "country-state-city";
import apiClient from "../../../helpers/apiClient";

const US_COUNTRY_ISO = "US";

const FALLBACK_COVERAGE_STATES = [
    { abbreviation: "PA", fullName: "Pennsylvania" },
    { abbreviation: "CO", fullName: "Colorado" },
    { abbreviation: "CT", fullName: "Connecticut" },
    { abbreviation: "NV", fullName: "Nevada" },
    { abbreviation: "SC", fullName: "South Carolina" },
    { abbreviation: "MD", fullName: "Maryland" },
    { abbreviation: "GA", fullName: "Georgia" },
    { abbreviation: "CA", fullName: "California" },
    { abbreviation: "TX", fullName: "Texas" },
    { abbreviation: "AZ", fullName: "Arizona" },
    { abbreviation: "FL", fullName: "Florida" },
    { abbreviation: "HI", fullName: "Hawaii" },
    { abbreviation: "IL", fullName: "Illinois" },
    { abbreviation: "IN", fullName: "Indiana" },
    { abbreviation: "MO", fullName: "Missouri" },
    { abbreviation: "OR", fullName: "Oregon" },
    { abbreviation: "TN", fullName: "Tennessee" },
];

const useUsStatesWithCoverage = () => {
    const [states, setStates] = useState([]);
    const [loading, setLoading] = useState(false);
    const [coverageStates, setCoverageStates] = useState([]);

    useEffect(() => {
        const fetchCoverageStates = async () => {
            try {
                setLoading(true);
                const response = await apiClient.get("/api/insurance/teqMobility-coverage-states");
                if (response?.data?.success && response?.data?.data?.states?.length) {
                    setCoverageStates(response.data.data.states);
                } else {
                    setCoverageStates(FALLBACK_COVERAGE_STATES);
                }
            } catch {
                setCoverageStates(FALLBACK_COVERAGE_STATES);
            } finally {
                setLoading(false);
            }
        };

        fetchCoverageStates();
    }, []);

    useEffect(() => {
        setLoading(true);
        const filteredStates = State.getStatesOfCountry(US_COUNTRY_ISO).map((state) => {
            const result = coverageStates.find(
                (coveredState) => coveredState?.fullName?.toLowerCase() === state.name.toLowerCase(),
            );
            return {
                ...state,
                isInsuranceEnabled: !!result,
            };
        });
        setStates(filteredStates);
        setLoading(false);
    }, [coverageStates]);

    return { states, loading };
};

export default useUsStatesWithCoverage;
